export default __webpack_public_path__ + "static/media/g-label.5e2883ee.svg";